import {get} from "lodash"
import BaseService from "./Base"

class WebFormService extends BaseService {
    async generateSapDocuments(payload: {
        slug: string
        sapCheckpointCheckIds: number[]
        departmentId: number
        departmentSubunitId: number
    }): Promise<{success: boolean; batchId: string; total: number}> {
        const baseURL = process.env.REACT_APP_WEBFORMS_BASE_URL
        if (!baseURL) {
            throw new Error("REACT_APP_WEBFORMS_BASE_URL is not configured")
        }
        const response = await this.post("/sap-form/bulk-documents", payload, {baseURL})
        return get(response, "data")
    }

    async getReportForms(params = {}) {
        const response = await this.post("/v1/admin-reports/1098T-form-report/list", params)
        return get(response, "data.data", {})
    }

    async getGenerateForms(params = {}) {
        const response = await this.post("/v1/admin-reports/1098T-form/save", params)
        return get(response, "data.data", {})
    }
}

export default WebFormService
